import { useEffect } from 'react';
import { installPlatformErrorCapture } from '@/lib/platformLogs';

/**
 * Branche le journal central des erreurs dès le démarrage de l'application :
 * erreurs JavaScript, promesses rejetées et réponses HTTP en échec sont
 * envoyées dans `/superadmin/logs` avec la page concernée.
 */
export default function PlatformErrorReporter() {
  useEffect(() => {
    installPlatformErrorCapture();
  }, []);
  return null;
}